import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import BaseTooltip from '@deprecated-ui/common/Tooltip';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import { Select } from 'antd';

const PriceWrapper = styled(Flex).attrs({
  wrap: 'wrap',
  align: 'flex-end',
  justify: 'flex-end',
  width: '100%',
  direction: 'column',
})`
  margin-left: 30px;
  max-width: 150px;
`;

const BidOfferWrapper = styled(Flex)`
  margin-left: 10px;
  display: flex;

  @media ${device.tablet} {
    display: none;
  }
`;

const BidOffer = styled(Flex).attrs({ width: '70px', height: '30px' })`
  border: 1px solid ${color.gainsboro};
`;

const LeftBox = styled(Flex).attrs({
  width: '40%',
  height: '100%',
  align: 'center',
  justify: 'center',
})`
  background: ${color.gainsboro};
  border-right: 1px solid ${color.gainsboro};
`;

const RightBox = styled(Flex).attrs({
  width: '60%',
  height: '100%',
  align: 'center',
  justify: 'center',
})``;

const SyariahLabelWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  px: '5px',
  py: '2px',
  ml: '5px',
})`
  border: 1px solid ${color.primary};
  border-radius: 4px;
`;

const NotationPopoverWrapper = styled(Flex).attrs({
  direction: 'column',
  align: 'center',
  justify: 'center',
  padding: '20px',
  width: '350px',
})`
  position: absolute;
  top: 110px;
  left: -5%;
  z-index: 9999;
  border: 1px solid ${color.gainsboro};
  background: ${color.light};

  @media ${device.tablet} {
    top: 95px;
    left: -15%;
  }
`;

const NotationCodeBox = styled(Flex).attrs({
  width: '30px',
  align: 'center',
  justify: 'center',
  mr: '10px',
})`
  background-color: rgba(255, 199, 116, 0.1);
  border: 1px solid #eba031;
  border-radius: 4px;
`;

const NotationDesc = styled(Text).attrs({
  margin: '0 0 10px 10px',
  py: '5px',
})`
  border-bottom: 1px solid ${color.downgray};
`;

const SymbolAvatar = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  background: #3a645c;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

const CustomTooltip = styled(BaseTooltip)``;

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${color.light};
`;

const TransactionFormSelect = styled(Select)`
  width: 120px;
`;

export {
  PriceWrapper,
  BidOfferWrapper,
  BidOffer,
  LeftBox,
  RightBox,
  SyariahLabelWrapper,
  NotationPopoverWrapper,
  NotationCodeBox,
  NotationDesc,
  SymbolAvatar,
  CustomTooltip,
  TooltipContainer,
  TransactionFormSelect,
};
